import styles from "./ImageUploader.module.css"

import app from '../../../firebase';

import { db } from '../../../firebase';
import { doc, setDoc } from "firebase/firestore";

import { useAuth } from '../../../contexts/authContext';

export default function ImageUploader(props) {
  const {currentUser} = useAuth()

  const onFileChange = async (e) => {
    const searchParams = new URLSearchParams(window.location.href)

    const file = e.target.files[0]
    const storageRef = app.storage().ref();
    const fileRef = storageRef.child(`${searchParams.get("designId")} ${file.name}`)

    await fileRef.put(file);

    const fileURL = await fileRef.getDownloadURL()

    const docRef = doc(db, "users", currentUser.uid);

    const obj = {};

    obj.allDesigns = {}

    obj.allDesigns[searchParams.get("designId")] = {
      imgSrc: fileURL,
    }

    await setDoc(docRef, obj, {merge:true});

    props.setUserImage(fileURL);
  }

  return (
    <div className={styles.imageUploader} style={{display: `${props.userImage ? "none" : "flex"}`}}>
      <label htmlFor='image-upload-input'>Click to upload an image</label>
      <input type="file" id="image-upload-input" className={styles.imageUploadInput} onChange={onFileChange} accept="image/png, image/jpg, image/jpeg, image/tif, image/tiff, image/jfif" />
    </div>
  );
}
